





























































import { Component, Vue } from "vue-property-decorator";
import { WithdrawUpdate, Wallet, Withdraw } from "@/interfaces";
import {
  dispatchGetWithdraws,
  dispatchUpdateWithdraw,
  dispatchGetWithdrawStates
} from "@/store/main/actions";
import { readOneWithdraw } from "@/store/main/getters";
import {
  dispatchGetWallets,
  dispatchGetCurrencies
} from "@/store/wallet/actions";
import { readCurrencyName, readUserOneWallet } from "@/store/wallet/getters";

@Component
export default class EditWithdraw extends Vue {
  public valid = true;
  public loading = true;
  public done_datetime = "";

  public withdraw: Withdraw | null = null;
  public wallet_: Wallet | null = null;

  public async mounted() {
    this.loading = true;
    await Promise.allSettled([
      dispatchGetWithdraws(this.$store),
      dispatchGetWallets(this.$store),
      dispatchGetWithdrawStates(this.$store),
      dispatchGetCurrencies(this.$store)
    ]);
    const withdraw = readOneWithdraw(this.$store)(
      +this.$router.currentRoute.params.id
    );
    if (withdraw) this.withdraw = withdraw;
    const wallet_id = this.withdraw?.to_wallet_id;
    if (wallet_id) {
      const wallet = readUserOneWallet(this.$store)(wallet_id);
      if (wallet) this.wallet_ = wallet;
    }
    this.reset();
    this.loading = false;
  }

  public reset() {
    this.$validator.reset();
    if (this.withdraw && this.withdraw.done_datetime) {
      this.done_datetime = this.withdraw.done_datetime;
    }
  }

  public cancel() {
    this.$router.back();
  }

  public async submit() {
    if ((await this.$validator.validateAll()) && this.done_datetime) {
      const withdraw: WithdrawUpdate = {
        done_datetime: this.done_datetime
      };
      if (this.done_datetime) {
        withdraw.done_datetime = this.done_datetime;
      }
      await dispatchUpdateWithdraw(this.$store, {
        id: this.withdraw!.id,
        withdraw: withdraw
      });
      this.$router.push("/main/withdraws");
    }
  }


  get from_amount() {
    const amount = this.withdraw?.from_amount;

    if (!this.withdraw?.currency) return "----";

    const currency = readCurrencyName(this.$store)(this.withdraw?.currency);

    if (currency === "IRT") {
      if (amount) return (+amount.toFixed(0)).toLocaleString() + "تومان";
    } else if (currency === "ETH") {
      if (amount) return (amount / 10 ** 18).toFixed(5) + "ETH";
    }else if (currency === "ETC") {
      if (amount) return (amount / 10 ** 18).toFixed(5) + "ETC";
    }else if (currency === "ZIL") {
      if (amount) return (amount / 10 ** 12).toFixed(5) + "ZIL";
    }else if (currency === "XCH") {
      if (amount) return (amount / 10 ** 12).toFixed(5) + "XCH";
    }else if (currency === "XCC") {
      if (amount) return (amount / 10 ** 8).toFixed(5) + "XCC";
    }
    return "----";
  }
}
